module.exports = __webpack_public_path__ + "img/orange_077.8f89680a.png";